
<div class="container" [ngClass]="{ 'useTopSpace': useTopSpace }">
    <div class="row title_1">
        <div class="col typo_1" [ngClass]="{'color-blue-light': useThemeDark}">
            <span>{{ title }}</span>
            <flags *ngIf="useFlag" [useInline]="true"></flags>
        </div>
    </div>
    <img class="mt-8r mb-32r" src="assets/images/Separator_Multi.svg"/>
</div>